<template>
  <div>
    <div class="ntak-dashboard-container" :class="{'hidden-form': !showForm}">
      <h1 class="ntak-dashboard-title">
        NTAK Dashboard
      </h1>

      <div>
        <a-form
            :form="form"
            layout="vertical"
        >
          <a-form-item label="Iroda">
            <a-select
                v-decorator="[
                            'id',
                            {
                                rules: [
                                    {
                                    required: isAdmin || isViewer,
                                    whitespace: true,
                                    message: 'Kérjük töltse ki!',
                                    type: 'integer'
                                  },
                                ],
                                validateTrigger: ['blur','keyup']
                            }
                        ]"
                placeholder="Kezdjen gépelni"
                showSearch
                :showArrow="false"
                :defaultActiveFirstOption="false"
                :filterOption="false"
                :style="{width: '100%'}"
                v-on:change="(value) => officeId = value"
                v-on:search="officeAutoComplete"
                v-on:dropdownVisibleChange="officeAutoComplete"
                :notFoundContent="officeOptionsLoading ? undefined : null"
            >
              <a-spin v-if="officeOptionsLoading" slot="notFoundContent" size="small" />

              <a-select-option
                  v-for="option in officeOptions"
                  :key="option.id"
                  :value="option.id"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </div>
    </div>

    <div>
      <iframe :class="{'hidden-form': !showForm}" :src="`/api/v1/companies/1/compass/${officeId}/`" />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import axios from "axios";
import { mapState } from "vuex";

export default {
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },

  data() {
    return {
      officeId: "??as",
      submitLoading: false,
      officeOptions: [],
      officeOptionsLoading: false
    }
  },

  computed: {
    ...mapState({
      office: state => state.user.office,
      roles: state => state.user.roles,
      selectedRole: state => state.user.selectedRole
    }),

    isAdmin() {
      return this.$store.getters.hasRoleAvailable(['ROLE_MTU_ADMIN']);
    },

    isViewer() {
      return this.$store.getters.hasRoleAvailable(['ROLE_MTU_VIEWER']);
    },

    showForm() {
      return this.isAdmin || this.isViewer;
    }
  },

  mounted() {
    if (this.office) {
      this.officeOptions = [this.office];
      this.form.setFieldsValue({
        'id': this.office.id
      });
      this.officeId = this.office.id;
    }
  },

  watch: {
    selectedRole(role) {
      switch (role) {
        case 'ROLE_MTU_ADMIN':
        case 'ROLE_MTU_VIEWER':
          break;

        case 'ROLE_OFFICE_LEADER':
          this.setOffice(this.office);
          break;

        default:
          this.$router.replace(({ name: 'neta-home' }));
      }
    }
  },

  methods: {
    setOffice(office) {
      this.officeOptions = [office];
      this.form.setFieldsValue({
        'id': office.id
      });
      this.officeId = office.id;
    },

    /**
     * Auto-complete office list from API
     *
     * @param {string} name
     *
     * Throttled: 250ms when code is not empty
     */
    officeAutoComplete: function (name) {
      var self = this;

      let apiUrl = '/api/v1/companies/1/attractions/office';

      debounce(function (name) {
        self.officeOptions = [];
        self.officeOptionsLoading = true;

        axios.get(apiUrl, {
          params: {
            locale: self.$store.state.attraction.locale,
            name: (true !== name && name) ? '*' + name + '*' : null,
            fields: 'id,name',
            order: 'name ASC',
            limit: 200,
            status: '!= 2'
          }
        }).then(response => {
          self.officeOptions = response.data;
          self.officeOptionsLoading = false;
        });
      }, name !== true ? 250 : 0)(name)
    },
  }
}

</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 224px);
  border: 0;
  display: block;
}

iframe.hidden-form {
  height: calc(100vh - 64px);
}

.ntak-dashboard-container {
  padding: 25px;
  padding-bottom: 0;
  max-width: 600px;
  margin: auto;
}

.ntak-dashboard-container.hidden-form {
  display: none;
}
</style>